
import { Vue, Component, Prop } from "vue-property-decorator";
import Processing from '@/components/common/Processing.vue';
import Spinner from '@/components/common/Spinner.vue';


@Component({
  components: {
    Processing,
    Spinner,
  },
})
export default class LoadingOverlay extends Vue {
  @Prop({ type: Boolean, default: false }) readonly hasData!: boolean;
  @Prop({ type: Boolean, required: true }) readonly loading!: boolean;
  @Prop({ type: Boolean, default: false }) readonly spinnerCentered!: boolean;


  get spinnerCenteredStyles(): Object {
    if (this.spinnerCentered) {
      return " w-full items-center";
    }
  }

  get showNoInformation(): boolean {
    return !this.hasData && !this.loading;
  }
}
